enum AddonVariant {
  AppleMusic = 'AppleMusic',
  AppleMusicProfile = 'AppleMusicProfile',
  InstagramProfile = 'InstagramProfile',
  Link = 'Link',
  Location = 'Location',
  Spotify = 'Spotify',
  SpotifyProfile = 'SpotifyProfile',
  TikTokProfile = 'TikTokProfile',
  TwitterProfile = 'TwitterProfile',
  Venmo = 'Venmo',
  YouTubeProfile = 'YouTubeProfile'
}
export default AddonVariant
